// working in responsive 10 jan 2025
import React from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import { PencilSimple } from "phosphor-react";
import RequiredLabel from "../CustomCommons/RequiredLabel";
import PhoneInput from "react-phone-input-2";
import "./invoice.css";

import Select from "react-select";
import DoIcon from "../CustomCommons/DoIcon";

import { handleInputs } from "../../utils/HandleInputs";
import { showToast } from "../../utils/ToastHelper";
import axios from "axios";
import { BASE_URL } from "../Const/Url";
import { useEffect } from "react";
import SelectDropDown from "../CustomCommons/SelectDropDown";
import swal from "sweetalert";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import PreviewCreate from "./PreviewCreate";
import * as path from "./../Routes/RoutePaths";
import { useHistory } from "react-router-dom";
import Loader from "../CustomCommons/Loader";
import { can_add_invoice, has_permissions } from "../CustomCommons/utils";
import Permission from "../CustomCommons/Permission";
import Scanner2 from "./Scanner2";
import divisions from "../../assets/json/bd_divisions.json";
import { Controller, useForm } from "react-hook-form";
import SelectOpenWithPaggination from "../Const/SelectOpenWithPaggination";
import CreateWithPathao from "./Pathao/CreateWithPathao";
import SelectCustomType from "../CustomCommons/SelectCustomType";
import { MoonLoader } from "react-spinners";

const CreateInvoiceWithLoading = () => {
  const [invoiceLoader, setInvoiceLoader] = useState(false);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [deliveryService, setDeliveryService] = useState({
    label: "Pathao",
    value: 0,
  });

  const [FoundCustomer, setFoundCustomer] = useState({
    id: "",
    total_purchase: "",
    created_at: "",
    updated_at: "",
    name: "",
    mobile: "",
    email: "",
    status: "",
    address: "",
  });
  const [Found, setFound] = useState(false);
  // pathao data
  const [pathaoCity, setPathaoCity] = useState({
    label: "",
    value: "",
  });
  const [pathaoZone, setPathaoZone] = useState({
    label: "",
    value: "",
  });
  const [pathaoArea, setPathaoArea] = useState({
    label: "",
    value: "",
  });
  // pathao data
  const [selectedDivision, setSelectedDivision] = useState({
    label: "",
    value: "",
  });
  const [selectedDistrict, setSelectedDistrict] = useState({
    label: "",
    value: "",
  });
  const [selectedTown, setSelectedTown] = useState({ label: "", value: "" });
  const [selectLoading, setSelectLoading] = useState(false);
  // Address Form methods start
  const {
    register,
    control,
    watch,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    console.log(FoundCustomer, "found");
    if (Found) {
      SetInvoiceAllData((prevState) => ({
        ...prevState,
        invoice_bill_to: FoundCustomer.name,
      }));
      //  new changes
      if (FoundCustomer.redex_area) {
        setCustomCharge(
          Number(FoundCustomer?.redex_area_details.delivery_charge)
        );
        reset({
          division: {
            label: FoundCustomer.redex_division_details.name,
            value: FoundCustomer.redex_division_details.id,
          },
          district: {
            label: FoundCustomer.redex_district_details.name,
            value: FoundCustomer.redex_district_details.id,
          },
          town: {
            label: FoundCustomer.redex_area_details.name,
            value: FoundCustomer.redex_area_details.id,
          },
          // zip: { label: sInvoice.to_zip_code, value: sInvoice.to_zip_code }
          zip: FoundCustomer.to_zip_code,
        });
        setSelectedDivision({
          label: FoundCustomer.redex_division_details.name,
          value: FoundCustomer.redex_division_details.id,
        });
        setSelectedDistrict({
          label: FoundCustomer.redex_district_details.name,
          value: FoundCustomer.redex_district_details.id,
        });
        setSelectedTown({
          label: FoundCustomer.redex_area_details.name,
          value: FoundCustomer.redex_area_details.id,
        });
      } else {
        reset({
          division: { label: FoundCustomer.to_division, value: "" },
          district: { label: FoundCustomer.to_district, value: "" },
          town: { label: FoundCustomer.to_city, value: "" },
          // zip: { label: sInvoice.to_zip_code, value: sInvoice.to_zip_code }
          zip: FoundCustomer.to_zip_code,
        });
        setSelectedDivision({ label: FoundCustomer.to_division, value: "" });
        setSelectedDistrict({ label: FoundCustomer.to_district, value: "" });
        setSelectedTown({ label: FoundCustomer.to_city, value: "" });
      }
    }
  }, [Found, FoundCustomer, reset]);
  const [districtList, setDistrictList] = useState([]);
  const [upazillaList, setUpazillaList] = useState([]);
  const watchFields = watch([
    // "town",
    "division",
    "district",
    "town",
    "zip",
  ]);
  useEffect(() => {
    if (selectedDivision.value !== "") {
      axios
        .get(
          `${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivision.value}/`
        )
        .then((response) => {
          // setDistrictList(response.data.data.districts)
          if (response.data.data.districts !== undefined) {
            setDistrictList(response.data.data.districts);
          } else {
            setDistrictList([]);
          }
        });
    }
  }, [selectedDivision]);
  useEffect(() => {
    if (selectedDistrict.value !== undefined) {
      const foundAreas = districtList.filter(
        ({ id }) => id == selectedDistrict.value
      )[0]?.areas;
      // setUpazillaList(foundAreas)
      if (foundAreas !== undefined) {
        setUpazillaList(foundAreas);
      } else {
        setUpazillaList([]);
      }
    }
  }, [selectedDistrict, districtList]);
  const handleDivisionChange = (division) => {
    if (selectedDivision?.value !== undefined) {
      setSelectedDistrict({ label: "", value: "" });
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setDistrictList([]);
      setSelectLoading(true);
      setCustomCharge(0);
      setSelectedDivision(division);
      setValue("division", division);
      const selectedDivisionId = division.value;
      axios
        .get(
          `${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivisionId}/`
        )
        .then((response) => {
          // setDistrictList(response.data.data.districts)
          if (response.data.data.districts !== undefined) {
            setDistrictList(response.data.data.districts);
          } else {
            setDistrictList([]);
          }
        });
    }
  };
  const handleDistrictChange = (district) => {
    if (selectedDistrict?.value !== undefined) {
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setUpazillaList([]);
      setSelectLoading(false);
      setCustomCharge(0);
      setSelectedDistrict(district);
      setValue("district", district);
      const selectedDistrictId = district.value;
      const foundAreas = districtList.filter(
        ({ id }) => id == selectedDistrictId
      )[0]?.areas;
      // setUpazillaList(foundAreas)
      if (foundAreas !== undefined) {
        setUpazillaList(foundAreas);
      } else {
        setUpazillaList([]);
      }
    }
    // if (watchFields[2].label !== )
  };
  const handleTownChange = (town) => {
    if (selectedTown?.value !== undefined) {
      setValue("zip", "");
      setSelectedTown(town);
      setValue("town", town);
      const selectedAreaId = town.value;
      const foundDeliveryCharge = upazillaList?.filter(
        ({ id }) => id == selectedAreaId
      )[0]?.delivery_charge;
      // setCustomCharge(foundDeliveryCharge)
      if (foundDeliveryCharge !== undefined) {
        console.log(foundDeliveryCharge, selectedAreaId, "fdc");
        setCustomCharge(Number(foundDeliveryCharge));
      }
    }
  };

  const [scanedCode, setScanCode] = useState("");
  const [OnlogoutHide, setOnlogoutHide] = useState(0);
  const [inputQuery, setInputQuery] = useState("");
  const mainEmail = "kaarujbangladesh@gmail.com";
  const mainName = "KAARUJ";
  const mainAddress = "Road: 42, Gulshan 2, Dhaka, Bangladesh";
  const mainMobile = "+8801980907892";
  const [isLoading, SetisLoading] = useState(false);
  const [defaultValue, setdefaultValue] = useState([]);
  const [metaSelect, setMetaSelect] = useState({
    action: "select-option",
    name: "",
    option: {},
  });

  const print = useRef();
  const [selectedOption, setSelectedOption] = useState(null);
  const [Thumb, setThumb] = useState(null);
  useEffect(() => {
    setScanCode("");
  }, []);
  const delivery_charge = {
    0: 80,
    1: 150,
  };
  const invoice_choices = [
    { value: 0, label: "Recieved" },
    { value: 1, label: "Pending" },
    { value: 2, label: "Refunded" },
  ];
  const invoice_choices1 = [
    { value: 1, label: "Pending" },
    { value: 0, label: "Recieved" },
    { value: 2, label: "Refunded" },
  ];

  const delivery_choices = [
    { value: 3, label: "Pending" },
    { value: 1, label: "Order Placed" },
    { value: 0, label: "Returned" },
    { value: 2, label: "Delivered" },
    { value: 4, label: "Hold" },
    { value: 5, label: "Dispatched" },
  ];
  const paymentType = [
    { value: 0, label: "Cash On Delivery" },
    { value: 1, label: "Card" },
    { value: 2, label: "Bank Transfer" },
    { value: 3, label: "Bkash" },
    { value: 4, label: "SSLECOMMERZ" },
    { value: 5, label: "Nagad" },
    { value: 6, label: "Kaaruj Delivery" },
  ];
  const [pS, setPs] = useState(0);

  const [fromCode, setFromCode] = useState("880");
  const [toCode, setToCode] = useState("880");
  const [customCharge, setCustomCharge] = useState(80);
  console.log("crg", customCharge);
  const today = new Date();

  const formattedDate = today.toISOString().split("T")[0];
  const [InvoiceAllData, SetInvoiceAllData] = useState({
    invoice_date: formattedDate,
    invoice_due_date: "",
    invoice_bill_from: mainName,
    invoice_bill_to: "",
    invoice_from_mobile: mainMobile.replace("+880", ""),
    invoice_to_mobile: "",
    invoice_from_email: mainEmail,
    invoice_to_email: "",
    invoice_from_address: mainAddress,
    invoice_to_address: "",
    invoice_to_address2: "",
    to_zip_code: "",
    to_country: "Bangladesh",
    to_district: "",
    to_division: "",
    to_city: "",
    invoice_notes: "",
    invoice_delivery_charge: 0,
  });

  const [paymentAllData, setPaymentAllData] = useState({
    card_holder_name: "",
    card_number: "",
    bank_name: "",
    banK_account_number: "",
    banK_account_name: "",
    banK_branch_name: "",
    bkash_number: "",
    bkash_trx_number: "",
    nagad_number: "",
    nagad_trx_number: "",
    reference_id: "",
  });
  const clearPaymentALlData = () => {
    setPaymentAllData({
      card_holder_name: "",
      card_number: "",
      bank_name: "",
      banK_account_number: "",
      banK_account_name: "",
      banK_branch_name: "",
      bkash_number: "",
      bkash_trx_number: "",
      nagad_number: "",
      nagad_trx_number: "",
      reference_id: "",
    });
  };
  const [invoice_status, setinvoice_status] = useState(1);
  const [Delivery_status, setDelivey_status] = useState(3);
  const [invoice_delivery_type, setinvoice_delivery_type] = useState(0);
  const [invoice_discount_type, setinvoice_discount_type] = useState(1);
  const [invoice_payment_type, setinvoice_payment_type] = useState(0);
  const [invoice_delivery_charge, setinvoice_delivery_charge] = useState(2);
  const [InvoiceBelowData, SetInvoiceBelowData] = useState({
    invoice_vat: 0,
    invoice_tax: 0,
    invoice_due: 0,
    invoice_paid: 0,
    invoice_total: 0,
  });
  // console.log("------------------------------");
  // console.log("invoice_payment_type", invoice_payment_type);
  // console.log("------------------------------");

  const [optional, setOptional] = useState("");
  const [URL, setURL] = useState("");
  const [fileName, setFileName] = useState("");
  const [Items, SetItems] = useState([]);
  const [Signature, SetSignature] = useState(null);
  const [ProductsList, setProductsList] = useState([]);
  const [CustomerList, setCustomerList] = useState([]);
  const [ProductCom, setProductCom] = useState([]);
  const [mainState, setMainState] = useState({});
  const [mainInnerState, setMainInnerState] = useState({});
  const [Jdata, setJData] = useState([]);
  useEffect(() => {
    let temp1 = mainState;
    console.log(temp1, "--------mainState found temp1------");

    var output = [];
    for (let i in temp1) {
      console.log(temp1[i]["variantObj"]);
      for (let j in temp1[i]["variantObj"]) {
        console.log(j);
        console.log(temp1[i]["variantObj"][j]);
        const d = temp1[i]["variantObj"][j];
        d.total !== 0 &&
          output.push({
            name: i,
            basePrice: temp1[i].price,
            thumb: temp1[i].thumb ? temp1[i].thumb : temp1[i].thumb_url,
            discount: isNaN(temp1[i].discount) === true ? 0 : temp1[i].discount,
            price: d["price"],
            quantity: d["quantity"],
            id: d["id"],
            total: d["total"],
            variant: d["name"],
          });
      }
    }
    setJData(output);
  }, [mainState]);
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      color: state.selectProps.menuColor,
    }),
  };

  const convertData = (date) => {
    var current = new Date(date);
    return current.toISOString().substring(0, 10);
  };

  function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
  const history = useHistory();
  const ValidateData = (sendEmail) => {
    const bd = /^[1][0-9]{9}$/;

    if (InvoiceAllData["invoice_date"] === "") {
      showToast("error", "Invoice  Date can't be empty..");
      return 0;
    } else if (!bd.test(InvoiceAllData["invoice_from_mobile"])) {
      showToast("error", "From Mobile : Please Enter Valid phone number");
      return 0;
    } else if (!bd.test(InvoiceAllData["invoice_to_mobile"])) {
      showToast("error", "To Mobile : Please Enter Valid phone number");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_bill_from"] === "") {
      showToast("error", "Bill from  can't be empty..");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_bill_to"] === "") {
      showToast("error", "Bill to  can't be empty..");
      return 0;
    }

    if (InvoiceAllData["invoice_from_email"] === "") {
      showToast("error", "From email  can't be empty..");
      return 0;
    } else if (!validateEmail(InvoiceAllData["invoice_from_email"])) {
      showToast("error", "From email  not valid..");
      return 0;
    } else if (
      Found &&
      !validateEmail(FoundCustomer?.email) === "" &&
      InvoiceAllData["invoice_to_email"].length > 0
    ) {
      showToast("error", "To email  not valid...");
      return 0;
    } else if (
      !Found &&
      !validateEmail(InvoiceAllData["invoice_to_email"]) &&
      InvoiceAllData["invoice_to_email"].length > 0
    ) {
      showToast("error", "To email  not valid..");
      return 0;
    } else if (InvoiceAllData["invoice_from_address"] === "") {
      showToast("error", "From address  can't be empty..");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_to_address"] === "") {
      showToast("error", "To address  can't be empty..");
      return 0;
    } else if (
      InvoiceAllData["invoice_to_address"].length < 10 &&
      FoundCustomer?.to_address.length < 10
    ) {
      showToast("error", "To address  should be more then 10 character..");
      return 0;
    }

    if (Object.keys(mainState).length <= 0) {
      showToast("error", "Product Details is empty..");
      return 0;
    }

    if (InvoiceAllData["invoice_notes"] === null) {
      showToast("error", "Notes is empty..");
      return 0;
    }
    // if (deliveryService === 1) {
    //   if (!watchFields[0]?.label && !FoundCustomer.to_division) {
    //     showToast("error", "Division is empty..");
    //     return 0;
    //   }

    //   if (!FoundCustomer.to_district && !watchFields[1]?.label) {
    //     showToast("error", "District is empty..");
    //     return 0;
    //   }
    //   if (!FoundCustomer.to_city && !watchFields[2]?.label) {
    //     showToast("error", "City is empty..");
    //     return 0;
    //   }
    // }
    // if (deliveryService === 0) {
    //   if (!pathaoCity?.label) {
    //     showToast("error", "City is empty..");
    //     return 0;
    //   }
    //   if (!pathaoZone?.label) {
    //     showToast("error", "Zone is empty..");
    //     return 0;
    //   }
    //   if (!pathaoArea?.label) {
    //     showToast("error", "Area is empty..");
    //     return 0;
    //   }

    // }

    for (const item in mainState) {
      const variantObj = mainState[item].variantObj;

      // Check if every variantObj.quantity is -1
      const isAllQuantitiesEmpty = Object.values(variantObj).every(
        (variant) => variant.quantity === -1
      );

      if (isAllQuantitiesEmpty) {
        showToast("error", `${item} Quantity is empty`);
        return 0; // Exit the function with 0
      }
    }
    if (deliveryService.value === 1 || deliveryService.value === "1") {
      if (!watchFields[0]?.label && !FoundCustomer.to_division) {
        showToast("error", "Division is empty.");
        return 0;
      } else if (!watchFields[1]?.label && !FoundCustomer.to_district) {
        showToast("error", "District is empty.");
        return 0;
      } else if (!watchFields[2]?.label && !FoundCustomer.to_city) {
        showToast("error", "City is empty.");
        return 0;
      }
    }
    if (deliveryService.value === 0 || deliveryService.value === "0") {
      if (!pathaoCity?.label) {
        showToast("error", "City is empty.");
        return 0;
      } else if (!pathaoZone?.label) {
        showToast("error", "Zone is empty.");
        return 0;
      } else if (!pathaoArea?.label) {
        showToast("error", "Area is empty.");
        return 0;
      }
    }

    postInvoice(sendEmail);
  };

  // };
  const [isSendingInvoiceProudct, setisSendingInvoiceProudct] = useState(false);
  // console.log("allvariants", allvariants);

  function formatInv(inputData) {
    const formattedData = [];

    // Iterate over the data object
    for (const key in inputData) {
      const product = inputData[key];
      const variants = product.variant;

      // Iterate over the variants array for each product
      for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];

        // Check if quantity is greater than 0
        if (variant.quantity > 0) {
          // Create a new formatted object using the variant data
          const formattedObject = {
            quantity: variant.quantity,
            total: variant.total.toString(),
            product_name: key.trim(),
            variant_name: variant.name,
            is_custom: false,
            invoice_date: InvoiceAllData["invoice_date"],
            product: product.id,
            variant: variant.id,
            is_regular: true,
          };

          // Add the formatted object to the formattedData array
          formattedData.push(formattedObject);
        }
      }
    }

    return formattedData;
  }

  const SaveAndSendEmail = () => {
    ValidateData(true);
  };

  const postInvoice = (sendEmail) => {
    const url = `${BASE_URL}api/v1/sales/inventory/invoice/`;
    const data = new FormData();

    const current_user = JSON.parse(localStorage.getItem("userData"));
    data.append(
      "invoice_date",
      InvoiceAllData["invoice_date"] !== "" &&
        convertData(InvoiceAllData["invoice_date"])
    );

    data.append("bill_from", InvoiceAllData["invoice_bill_from"]);
    data.append(
      "bill_to",
      Found ? FoundCustomer.name : InvoiceAllData["invoice_bill_to"]
    );
    data.append("from_email", InvoiceAllData["invoice_from_email"]);
    data.append(
      "to_email",
      Found ? FoundCustomer.email : InvoiceAllData["invoice_to_email"]
    );
    data.append(
      "from_mobile",
      `+${fromCode}${InvoiceAllData["invoice_from_mobile"]}`
    );
    data.append(
      "to_mobile",
      `+${toCode}${InvoiceAllData["invoice_to_mobile"]}`
    );
    data.append("from_address", InvoiceAllData["invoice_from_address"]);
    data.append(
      "to_address",
      Found ? FoundCustomer.address : InvoiceAllData["invoice_to_address"]
    );
    data.append(
      "delivery_charge",
      parseInt(invoice_delivery_charge) === 2
        ? customCharge
        : delivery_charge[InvoiceAllData["invoice_delivery_charge"]]
    );
    data.append("delivery_charge_type", parseInt(invoice_delivery_charge));

    data.append("total_discount", Discount);
    data.append("send_pdf", sendEmail);

    data.append("discount_type", invoice_discount_type);
    data.append(
      "product_list_json",
      JSON.stringify({
        mainstate: mainState,
        maininnerstate: mainInnerState,
      })
    );

    data.append("invoice_view_json", JSON.stringify(Jdata));

    data.append("payment_status", invoice_status.value);
    data.append("delivery_status", Delivery_status.value);
    data.append("delivery_type", invoice_delivery_type);
    data.append("payment_type", invoice_payment_type);
    data.append("payment_type", invoice_payment_type);
    data.append("card_holder_name", paymentAllData["card_holder_name"]);
    data.append("card_number", paymentAllData["card_number"]);
    data.append("card_expiry_date", paymentAllData["card_expiry_date"]);
    data.append("bank_name", paymentAllData["bank_name"]);
    data.append("banK_account_number", paymentAllData["banK_account_number"]);
    data.append("banK_routing_number", paymentAllData["banK_routing_number"]);
    data.append("banK_account_name", paymentAllData["banK_account_name"]);
    data.append("banK_branch_name", paymentAllData["banK_branch_name"]);
    data.append("bkash_number", paymentAllData["bkash_number"]);
    data.append("bkash_trx_number", paymentAllData["bkash_trx_number"]);
    // data.append("payment_status", 0);
    data.append("signature", Signature);
    data.append("notes", InvoiceAllData["invoice_notes"]);
    data.append("created_by", current_user.id);
    data.append("total_tax", 0);
    data.append("total_due", parseInt(getDueAmount()));
    data.append("total_paid", paid);
    data.append("total_amount", parseInt(getGrandTotal()));
    data.append("total_vat", 0);
    data.append("invoice_products", JSON.stringify(formatInv(mainState)));

    // SetisLoading(true);
    const data2 = {
      invoice_date:
        InvoiceAllData["invoice_date"] !== "" &&
        convertData(InvoiceAllData["invoice_date"]),
      bill_from: InvoiceAllData["invoice_bill_from"],
      bill_to: Found
        ? InvoiceAllData["invoice_bill_to"]
        : InvoiceAllData["invoice_bill_to"],
      from_email: InvoiceAllData["invoice_from_email"],
      to_email: Found
        ? FoundCustomer.email
        : InvoiceAllData["invoice_to_email"],
      from_mobile: `+${fromCode}${InvoiceAllData["invoice_from_mobile"]}`,
      to_mobile: `+${toCode}${InvoiceAllData["invoice_to_mobile"]}`,
      from_address: InvoiceAllData["invoice_from_address"],
      to_address: Found
        ? FoundCustomer.to_address
        : InvoiceAllData["invoice_to_address"],
      delivery_charge: customCharge,
      // delivery_charge:
      //   parseInt(invoice_delivery_charge) === 2
      //     ? customCharge
      //     : delivery_charge[InvoiceAllData["invoice_delivery_charge"]],
      delivery_charge_type: parseInt(invoice_delivery_charge),
      total_discount: Discount,
      send_pdf: sendEmail,
      discount_type: invoice_discount_type,
      product_list_json: JSON.stringify({
        mainstate: mainState,
        maininnerstate: mainInnerState,
      }),
      invoice_view_json: JSON.stringify(Jdata),
      payment_status: invoice_status.value
        ? invoice_status?.value
        : invoice_status,
      delivery_status: Delivery_status.value
        ? Delivery_status.value
        : Delivery_status,
      delivery_type: invoice_delivery_type,
      payment_type: invoice_payment_type,
      card_holder_name: paymentAllData["card_holder_name"],
      card_number: paymentAllData["card_number"],
      card_expiry_date: paymentAllData["card_expiry_date"],
      bank_name: paymentAllData["bank_name"],
      banK_account_number: paymentAllData["banK_account_number"],
      banK_routing_number: paymentAllData["banK_routing_number"],
      banK_account_name: paymentAllData["banK_account_name"],
      banK_branch_name: paymentAllData["banK_branch_name"],
      bkash_number: paymentAllData["bkash_number"],
      bkash_trx_number: paymentAllData["bkash_trx_number"],
      nagad_number: paymentAllData["nagad_number"],
      nagad_trx_number: paymentAllData["nagad_trx_number"],
      reference_id: paymentAllData["reference_id"],
      signature: Signature,
      notes: InvoiceAllData["invoice_notes"],
      created_by: current_user.id,
      total_tax: 0,
      total_due: parseInt(getDueAmount()),
      total_paid: paid,
      total_amount: parseInt(getGrandTotal()),
      sub_total: isNaN(getSubTotal()) ? 0 : getSubTotal(),
      total_vat: 0,
      invoice_products: formatInv(mainState),
      to_address2: Found
        ? FoundCustomer.to_address2
        : InvoiceAllData["invoice_to_address2"],
      to_country: Found
        ? FoundCustomer.to_country
        : InvoiceAllData["to_country"],
      to_district: Found ? FoundCustomer.to_district : watchFields[1]?.label,
      redex_division: watchFields[0]?.value,
      redex_district: watchFields[1]?.value,
      redex_area: watchFields[2]?.value,
      to_division: Found ? FoundCustomer.to_division : watchFields[0]?.label,
      to_zip_code: Found ? FoundCustomer.to_zip_code : watchFields[3],
      to_city: Found ? FoundCustomer.to_city : watchFields[2]?.label,
      is_regular: true,
      // pathao data
      delivery_service: deliveryService.value,
      pathao_city_name: pathaoCity.label ? pathaoCity.label : "",
      pathao_city_id: pathaoCity.value ? pathaoCity.value : 0,
      pathao_zone_name: pathaoZone.label ? pathaoZone.label : "",
      pathao_zone_id: pathaoZone.value ? pathaoZone.value : 0,
      pathao_area_name: pathaoArea.label ? pathaoArea.label : "",
      pathao_area_id: pathaoArea.value ? pathaoArea.value : 0,
    };
    setInvoiceLoader(true);

    axios
      .post(url, data2)
      .then((res) => {
        if (res.data.status) {
          // console.log(res);
          // postInvoiceProduct(res.data.data.id);
          // clearData();
          SetisLoading(false);

          showToast("success", "Invoice Created.");
          setInvoiceLoader(false);
          history.push(path.invoice_list);
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        // console.log(errorMsg);
        // for (let value of Object.values(errorMsg)) {
        //   showToast("error", value[0]);
        // }

        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
        SetisLoading(false);
        setInvoiceLoader(false);
      });
  };
  const getProductList2 = () => {
    console.log(scanedCode, "code");
    let url;
    if (scanedCode) {
      url = `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice/?query=${scanedCode}`;
    }

    axios
      .get(url)
      .then((res) => {
        // console.log("productlistinvoice", res.data);
        const result = res.data.data;

        const options = result.map((curr) => ({
          label: curr.name + " " + "[[" + curr?.sku + "]]",
          value: curr.id,
          price: curr.price,
          discount: curr.discount,
          stock: curr.stock,
          variant: curr.variants,
          thumb: `${curr.thumb}`,
        }));

        setProductsList(options);
        // setLoading(false);
        setScanCode("");
        if (options.length > 0) {
          let variants = options[0]?.variant.map((curr) => ({
            id: curr.id,
            name: curr.name,
            price: curr.price,
            stock: curr.stock,
            product: curr.product,
            quantity: -1,
            total: 0,
          }));
          const variantsObj = {};
          options[0]?.variant.map(
            (curr) =>
              (variantsObj[curr.name] = {
                id: curr.id,
                name: curr.name,
                price: curr.price,
                stock: curr.stock,
                product: curr.product,
                quantity: -1,
                total: 0,
              })
          );

          setMetaSelect({
            action: "select-option",
            name: undefined,

            option: {
              id: options[0]?.value,
              variant: variants,
              label: options[0]?.label,
              variantObj: variantsObj,
              price: parseInt(options[0]?.price),
              stock: parseInt(options[0]?.stock),
              thumb: options[0]?.thumb,
              discount: parseInt(options[0]?.discount),
            },
          });
          console.log("metaSlect2", metaSelect);
          setSelectedOption({});
          // handleMultiInputChange(options[0], metaSelect);
        }
      })
      .catch((err) => {
        // const message = JSON.parse(err.request.response).message;
        // console.log(err.request.response);
      });
  };
  console.log(InvoiceAllData["invoice_date"], "date");
  useEffect(() => {
    if (metaSelect?.option?.variant) {
      const newValue = {
        value: ProductsList[0].value,
        label: ProductsList[0].label,
      };
      // Check if the new value already exists in `defaultValue`
      const isValueExists = defaultValue.some(
        (item) => item.value === newValue.value
      );
      if (!isValueExists) {
        handleMultiInputChange(ProductsList[0], metaSelect);
        setdefaultValue([...defaultValue, newValue]);
      }
    }
  }, [metaSelect]);

  const getProductList = () => {
    if (inputQuery?.length > 1) {
      let url;
      if (!inputQuery || inputQuery === "" || inputQuery === undefined) {
        url = `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice/`;
      } else if (inputQuery) {
        url = `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice/?query=${inputQuery}`;
      }

      axios
        .get(url)
        .then((res) => {
          // console.log("productlistinvoice", res.data);
          const result = res.data.data;
          console.log(result, "------productlistinvoice-----");
          const options = result.map((curr) => ({
            label: curr.name + " " + "[[" + curr?.sku + "]]",
            value: curr.id,
            price: curr.price,
            discount: curr.discount,
            stock: curr.stock,
            variant: curr.variants,
            thumb: `${curr.thumb_url}`,
          }));

          setProductsList(options);
          // SetisLoading(false);
        })
        .catch((err) => {
          // const message = JSON.parse(err.request.response).message;
          // console.log(err.request.response);
        });
    }
  };

  // function debounce(func, delay) {
  //   let timeoutId;
  //   return function (...args) {
  //     clearTimeout(timeoutId);
  //     timeoutId = setTimeout(() => {
  //       func.apply(this, args);
  //     }, delay);
  //   };
  // }

  // const debouncedFetch = debounce(getProductList, 1000);

  const inputProduct = (inputValue) => {
    setInputQuery(inputValue);
  };
  console.log(
    {
      mainState: mainState,
      mainInnerState: mainInnerState,
    },
    "855"
  );

  const handleMultiInputChange = (newValue, actionMeta) => {
    // const newVal = actionMeta?.option?.label?.split("[[")[0];
    const newVal = actionMeta?.option?.label;
    setProductCom(newValue);
    console.log("newValue 123", newValue);
    console.log("newValue 1234", actionMeta?.option?.label);
    if (actionMeta.action === "select-option" && actionMeta?.option?.variant) {
      let variants = actionMeta?.option?.variant.map((curr) => ({
        id: curr.id,
        name: curr.name,
        price: curr.price,
        stock: curr.stock,
        product: curr.product,
        quantity: -1,
        total: 0,
      }));
      const variantsObj = {};
      actionMeta.option?.variant.map(
        (curr) =>
          (variantsObj[curr.name] = {
            id: curr.id,
            name: curr.name,
            price: curr.price,
            stock: curr.stock,
            product: curr.product,
            quantity: -1,
            total: 0,
          })
      );
      const NewData = {};

      // setMainState(
      //   {
      //   ...mainState,
      //   [newVal]: {
      //     id: actionMeta.option.value,
      //     variant: variants,
      //     variantObj: variantsObj,
      //     price: parseInt(actionMeta.option.price),
      //     stock: parseInt(actionMeta.option.stock),
      //     thumb: actionMeta.option.thumb,
      //     discount: parseInt(actionMeta.option.discount),
      //   },
      // }
      // );
      setMainState((prevMainState) => ({
        [newVal]: {
          id: actionMeta.option.value,
          variant: variants,
          variantObj: variantsObj,
          price: parseInt(actionMeta.option.price),
          stock: parseInt(actionMeta.option.stock),
          thumb: actionMeta.option.thumb,
          discount: parseInt(actionMeta.option.discount),
        },
        ...prevMainState,
      }));

      // console.log(mainState,'main')
      setdefaultValue([
        ...defaultValue,
        {
          value: actionMeta.option.value,
          label: newVal,
        },
      ]);
    }
    //remove data from select
    if (actionMeta.action === "remove-value") {
      delete mainInnerState[actionMeta.removedValue.label];
      setMainState({ ...mainInnerState });

      delete mainState[actionMeta.removedValue.label];
      setMainState({ ...mainState });

      setdefaultValue((prevDefaultValue) =>
        prevDefaultValue.filter(
          (value) =>
            value.label !== actionMeta.removedValue.label &&
            value.value !== actionMeta.removedValue.value
        )
      );
      setScanCode("");
    }
  };
  console.log(mainState, "mainState123");

  const handleInnerVariant = (currentName, value) => {
    setMainInnerState({
      ...mainInnerState,
      [currentName]: value,
    });
  };
  useEffect(() => {
    getProductList2();
    // setTimeout(() => {
  }, [scanedCode]);
  // useEffect(() => {
  //   if(inputQuery?.length > 3){
  //     getProductList();
  //   }
  //   // debouncedFetch()
  // }, [inputQuery]);

  // aftar

  // useEffect(() => {
  //   let timeoutId;
  //   const delayedFetch = () => {
  //     timeoutId = setTimeout(() => {
  //       getProductList();
  //     }, 1000); //
  //   };
  //   delayedFetch();
  //   return () => {
  //     clearTimeout(timeoutId);
  //   };
  // }, [inputQuery]);

  useEffect(() => {
    Object.keys(ProductsList).map((curr, index) => {
      setMainState({
        ...mainState,
        [curr]: { ...mainState[curr], in_price: ProductsList[index]["price"] },
      });
    });
  }, []);

  // console.log("CustomerList", CustomerList);
  const toPhoneHandle = (e) => {
    let value = `+${toCode}${e.target.value}`;
    let number = e.target.value;
    handleInputs(e, SetInvoiceAllData);
    if (number.length === 10) {
      const url = `${BASE_URL}/api/v1/inventory/inventory/customer/?limit=20&offset=0&filter=&search=${number}
      `;
      axios.get(url).then((res) => {
        if (res.data.data.results.length !== 0) {
          setPathaoCity({
            label: res.data.data.results[0].pathao_city_name
              ? res.data.data.results[0].pathao_city_name
              : "",
            value:
              res.data.data.results[0].pathao_city_id === 0
                ? ""
                : res.data.data.results[0].pathao_city_id,
          });

          setPathaoZone({
            label: res.data?.data?.results[0]?.pathao_zone_name,
            value:
              res.data?.data?.results[0]?.pathao_zone_id === 0
                ? ""
                : res.data?.data?.results[0]?.pathao_zone_id,
          });

          setPathaoArea({
            label: res.data?.data?.results[0]?.pathao_area_name
              ? res.data?.data?.results[0]?.pathao_area_name
              : "",
            value:
              res.data?.data?.results[0]?.pathao_area_id === 0
                ? ""
                : res.data?.data?.results[0]?.pathao_area_id,
          });
          setFound(true);
          setFoundCustomer(res.data.data.results[0]);
          showToast("success", "Found Customer");
        } else {
          setFound(false);
        }
      });
    }
  };

  const VariantThead = () => {
    return (
      <>
        {Object.keys(mainInnerState).length > 0 && (
          <thead style={{ border: "1.5px solid #E0E0E0" }}>
            <tr className="px-3" style={{ height: "45px" }}>
              <th
                className="minWidthForInvoiceCreateTable ps-4"
                style={{ width: "349px", textAlign: "start" }}
              >
                Variant
              </th>
              <th
                className="minWidthForInvoiceCreateTable  py-3"
                style={{ width: "150px", textAlign: "center" }}
              >
                Price
              </th>

              <th
                className="minWidthForInvoiceCreateTable  py-3"
                style={{ width: "150px", textAlign: "center" }}
              >
                In Stock
              </th>
              <th
                className="minWidthForInvoiceCreateTable py-3"
                style={{ width: "150px", textAlign: "center" }}
              >
                Quantity
              </th>

              <th
                className="minWidthForInvoiceCreateTable py-3"
                style={{ width: "150px", textAlign: "center" }}
              >
                Total
              </th>
            </tr>
          </thead>
        )}
      </>
    );
  };
  const [paid, setpaid] = useState(0);
  const [Discount, setDiscount] = useState(0);

  const getAllVariantName = () => {
    var res =
      mainInnerState !== undefined &&
      [].concat(
        ...Object.values(mainInnerState).map((a) => a.map((b) => b.label))
      );
    return res;
  };

  const getSubTotal = () => {
    const allarray = Object.values(mainState).map(
      (curr) =>
        curr.variant !== undefined &&
        curr.variant
          .map((variants) =>
            getAllVariantName().includes(variants.name)
              ? parseInt(variants.total)
              : 0
          )
          .reduce((a, b) => a + b, 0)
    );

    var sum = 0;
    for (let i in allarray) {
      sum += parseInt(allarray[i]);
    }
    return sum;
  };
  const getDiscountOrMainPrice = (curr, innerCur) => {
    return parseInt(
      mainState[curr] !== undefined &&
        (mainState[curr].discount === 0
          ? mainState[curr].price
          : mainState[curr].discount)
    );
  };
  const getBasePlusVariant = (curr, innerCur) => {
    return getDiscountOrMainPrice(curr, innerCur) + parseInt(innerCur.price);
  };
  const getFlatDiscount = () => {
    return Discount;
  };

  const getDeliveryCharge = () => {
    if (invoice_delivery_charge === 2) {
      return parseInt(customCharge);
    } else {
      return delivery_charge[invoice_delivery_charge];
    }
  };
  // prev 16april 2024
  // const getPercentageDiscount = () => {
  //   let total = getSubTotal() + parseInt(customCharge);
  //   return parseInt((Discount / 100) * total);
  // };
  // new 16april 2024
  const getPercentageDiscount = () => {
    let total = getSubTotal();
    return parseInt((Discount / 100) * total);
  };
  console.log(customCharge, "getPercentageDiscount");
  const getGrandTotal = () => {
    const discountCalc =
      invoice_discount_type === 0 || invoice_discount_type === "0"
        ? getFlatDiscount()
        : getPercentageDiscount();
    const charge = parseInt(customCharge);
    const beforeGrand = getSubTotal() + charge;
    const grand = beforeGrand - discountCalc;
    return grand < 0 ? 0 : parseInt(grand);
  };

  const getDueAmount = () => {
    const due = getGrandTotal() - paid;
    return due < 0 ? 0 : due;
  };
  const handlePrint = useReactToPrint({
    content: () => print.current,
    documentTitle: "emp-data",
    bodyClass: "dis",
  });
  const handlePrint2 = () => {
    if (
      InvoiceAllData["invoice_from_email"] !== "" ||
      InvoiceAllData["invoice_to_email"] ||
      InvoiceAllData["invoice_bill_to"] ||
      InvoiceAllData["invoice_bill_form"]
    ) {
      handlePrint();
    } else {
      swal("Empty Data,Please fill the form");
    }
  };

  const handleQuantity = (e, curr, innerCur) => {
    // HandleNewProductsInputValue(e, innerCur);
    const productName = curr;
    if (e.target.value < 0) {
      setPs(0);
    } else {
      setPs(e.target.value);
    }

    setMainState((prevInputs) => {
      const copiedObjects = Object.assign({}, mainState); // Shallow copy
      // console.log("copiedObjects", copiedObjects);
      // copiedObjects["Blankets"]["variant"][index]['quantity'] = 12; // Assign new value
      const keyOfVariant = Object.keys(
        copiedObjects[productName]["variant"]
      ).filter(
        (curr) =>
          copiedObjects[productName]["variant"][curr]["name"] === innerCur.label
      );
      const variantName = innerCur.label;
      // console.log("innercur", innerCur);
      if (parseInt(e.target.value) < 0) {
        copiedObjects[productName]["variant"][keyOfVariant]["quantity"] = 0;
        copiedObjects[productName]["variantObj"][variantName]["quantity"] = 0;
      } else if (parseInt(e.target.value) > innerCur.stock) {
        showToast("error", `Max Stock : ${innerCur.stock}`);
        copiedObjects[productName]["variant"][keyOfVariant]["quantity"] = 0;
        copiedObjects[productName]["variantObj"][variantName]["quantity"] = 0;
        copiedObjects[productName]["variant"][keyOfVariant]["quantity"] =
          innerCur.stock;
        copiedObjects[productName]["variantObj"][variantName]["quantity"] =
          innerCur.stock;
      } else {
        copiedObjects[productName]["variant"][keyOfVariant]["quantity"] =
          e.target.value;
        copiedObjects[productName]["variantObj"][variantName]["quantity"] =
          e.target.value;
      }

      let checkDiscountPrice =
        parseInt(copiedObjects[productName]["discount"]) === 0
          ? parseInt(copiedObjects[productName]["price"])
          : parseInt(copiedObjects[productName]["discount"]);
      // console.log("checkDiscountPrice", checkDiscountPrice);
      const baseAndVariant =
        parseInt(copiedObjects[productName]["variant"][keyOfVariant]["price"]) +
        checkDiscountPrice;
      copiedObjects[productName]["variant"][keyOfVariant]["total"] =
        parseInt(
          copiedObjects[productName]["variant"][keyOfVariant]["quantity"]
        ) * baseAndVariant;

      const baseAndVariantObj =
        parseInt(
          copiedObjects[productName]["variantObj"][variantName]["price"]
        ) + checkDiscountPrice;
      // console.log("baseAndVariantObj price--", baseAndVariantObj);
      copiedObjects[productName]["variantObj"][variantName]["total"] =
        parseInt(
          copiedObjects[productName]["variantObj"][variantName]["quantity"]
        ) * baseAndVariantObj;
      return copiedObjects; // Return copied object
    });
  };
  if (!has_permissions(can_add_invoice)) {
    return <Permission />;
  }
  if (isLoading) {
    return <Loader />;
  }

  console.log(
    {
      payment_status: invoice_status,
      delivery_status: Delivery_status,
    },
    "kaaruj pm"
  );

  return (
    <>
      <div className="categorey-parent">
        {/* ===============scaner============== */}
        <Scanner2 setScanCode={setScanCode} />
        {/* ===============scaner============== */}
        {/* ====================attribute=================== */}
        <div
          className="invoice-b my-4 bg-white cat-child"
          style={{ borderTop: "0.5px solid #E0E0E0" }}
        >
          <h4 className=" my-2 mb-4 padding-main-head">Product Details</h4>
          <div className="border-p"></div>
          <div className="padding-main">
            <SelectOpenWithPaggination
              handleMultiInputChange={handleMultiInputChange}
              inputProduct={inputProduct}
              ProductsList={ProductsList}
              defaultValue={defaultValue}
              setProductsList={setProductsList}
              inputQuery={inputQuery}
            />

            <div className="mt-3">
              <div
                className="rounded"
                style={{
                  background: "#FAFAFA",
                  display: "block",
                  overflowX: "scroll",
                  width: "100%",
                  msOverflowStyle: "none",
                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                <table className="item-tables table_my2">
                  <tbody>
                    {/* //Here-------------------------- */}
                    {Object.keys(mainState).map((curr, index) => {
                      // console.log("curr---------", curr);
                      // console.log("curr---------var", mainState[curr]["variant"]);
                      const variants = mainState[curr]["variant"];
                      const hasSingleOption =
                        variants && Object.values(variants).length === 1;

                      return (
                        <>
                          {mainState[curr]["variant"]?.length > 0 ? (
                            <>
                              <div
                                className="mt-4  px-2"
                                style={{
                                  background: " rgba(245, 245, 245, 0.36)",
                                  border: "none",
                                  height: "200px",
                                  minWidth: "600px",
                                  position: "relative",
                                  overflow: "visible", // Changed from overflowX: "scroll"
                                }}
                              >
                                <div
                                  className="row py-3 my-3"
                                  style={{ height: "45px" }}
                                >
                                  <div
                                    className="col-2 minWidthForInvoiceCreateTable ps-4"
                                    style={{ textAlign: "start" }}
                                  >
                                    <p>Product</p>
                                  </div>
                                  <div
                                    className="col-4 minWidthForInvoiceCreateTable  py-1"
                                    style={{ textAlign: "center" }}
                                  >
                                    Total Stock
                                  </div>
                                  <div
                                    className="col-5 minWidthForInvoiceCreateTable  py-1"
                                    style={{ textAlign: "center" }}
                                  >
                                    Variants
                                  </div>
                                </div>
                                <div
                                  className="row  "
                                  style={{ height: "45px" }}
                                >
                                  <div className="col-2 ps-4 py-1 d-flex align-items-center">
                                    <p className="text-capitalize">{curr}</p>
                                    <img
                                      width={50}
                                      style={{
                                        margin: "6px 0px !important",
                                        border: "0.2px solid #bcb0b0",
                                      }}
                                      height={50}
                                      src={
                                        !isLoading && mainState[curr]["thumb"]
                                      }
                                      alt="failed"
                                      className="ms-3 shadow-sm"
                                    />
                                    {/* {console.log(" mainState[curr][thumb", mainState[curr]["thumb"])} */}
                                  </div>
                                  <div className="col-4 py-1">
                                    <p className="text-capitalize text-center d-flex align-items-center justify-content-center">
                                      {Number(mainState[curr]["stock"])}
                                      {/* {Number(mainState[curr]["stock"]) - Number(pS)} */}
                                    </p>
                                  </div>
                                  <div className="col-5 text-center   py-1 pe-2">
                                    <div
                                      className=""
                                      style={{ marginTop: "-10px" }}
                                    >
                                      {/* <div className="" style={{ marginTop: "-10px" }}> */}
                                      <Select
                                        styles={{
                                          control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused
                                              ? "#e0e0e0"
                                              : "#e0e0e0",
                                            boxShadow: state.isFocused
                                              ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                                              : "none",
                                            "&:hover": {
                                              borderColor: "#e0e0e0",
                                            },
                                          }),
                                          menu: (baseStyles) => ({
                                            ...baseStyles,
                                            position: "absolute",
                                            zIndex: 99999,
                                            backgroundColor: "white",
                                            width: "100%",
                                            boxShadow:
                                              "0 2px 4px rgba(0,0,0,0.1)",
                                          }),
                                          menuList: (baseStyles) => ({
                                            ...baseStyles,
                                            maxHeight: "300px",
                                            overflowY: "auto",
                                          }),
                                          option: (baseStyles, state) => ({
                                            ...baseStyles,
                                            backgroundColor: state.isSelected
                                              ? "#f0f0f0"
                                              : "white",
                                            color: "#333",
                                            "&:hover": {
                                              backgroundColor: "#f5f5f5",
                                            },
                                          }),
                                          container: (baseStyles) => ({
                                            ...baseStyles,
                                            position: "relative",
                                            zIndex: 50,
                                          }),
                                          valueContainer: (baseStyles) => ({
                                            ...baseStyles,
                                            padding: "2px 8px",
                                          }),
                                          multiValue: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: "#f0f0f0",
                                          }),
                                        }}
                                        isMulti
                                        placeholder="-Select Variants-"
                                        isClearable
                                        value={selectedVariants[curr] || []}
                                        onChange={(value) => {
                                          handleInnerVariant(curr, value);
                                          setSelectedVariants({
                                            ...selectedVariants,
                                            [curr]: value,
                                          });
                                        }}
                                        options={
                                          mainState[curr]["variant"] !==
                                            undefined &&
                                          Object.values(
                                            mainState[curr]["variant"]
                                          ).map((curr) => ({
                                            label: curr.name,
                                            value: curr.id,
                                            price: curr.price,
                                            stock: curr.stock,
                                            quantity: 1,
                                          }))
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <table className="mapTable shadow-sm ms-2">
                                <thead
                                  className="mt-4"
                                  style={{
                                    background: " rgba(245, 245, 245, 0.36)",
                                  }}
                                ></thead>
                                <tbody className="innerTbody w-100">
                                  {mainInnerState !== undefined &&
                                    mainInnerState[curr] !== undefined &&
                                    mainInnerState[curr].map(
                                      (innerCur, index) => {
                                        return (
                                          <>
                                            {index === 0 && <VariantThead />}

                                            <tbody>
                                              <tr
                                                className="border-invoice"
                                                style={{ height: "45px" }}
                                              >
                                                <td className="ps-4 py-3">
                                                  <p className="text-capitalize">
                                                    {innerCur.label}
                                                  </p>
                                                  {/* <input className="invoiceCreateBigInputs" value={name} type="text" /> */}
                                                </td>
                                                <td
                                                  className="text-center   py-3"
                                                  style={{ minWidth: "300px" }}
                                                >
                                                  <input
                                                    name="in_price"
                                                    // onChange={(e) => HandleNewProductsInputValue(e, curr)}
                                                    value={getBasePlusVariant(
                                                      curr,
                                                      innerCur
                                                    )}
                                                    className="invoiceCreateSmallInputs"
                                                    placeholder="00.00"
                                                    type="text"
                                                    //
                                                  />
                                                </td>
                                                <td className="text-center   py-3">
                                                  <input
                                                    name="in_price"
                                                    // onChange={(e) => HandleNewProductsInputValue(e, curr)}
                                                    value={Number(
                                                      innerCur.stock
                                                    )}
                                                    className="invoiceCreateSmallInputs"
                                                    placeholder="00.00"
                                                    type="text"
                                                  />
                                                  {/* {console.log(mainState[curr]["variantObj"][innerCur],'------vvv----------')} */}
                                                </td>
                                                <td className="text-center   py-3">
                                                  <input
                                                    name="in_quantity"
                                                    onWheel={(e) =>
                                                      e.target.blur()
                                                    }
                                                    onChange={(e) =>
                                                      handleQuantity(
                                                        e,
                                                        curr,
                                                        innerCur
                                                      )
                                                    }
                                                    className="invoiceCreateSmallInputs"
                                                    placeholder="00.00"
                                                    type="number"
                                                    value={
                                                      (mainState ===
                                                        undefined &&
                                                        mainState[curr] ===
                                                          undefined &&
                                                        mainState[curr][
                                                          "variantObj"
                                                        ] === undefined &&
                                                        mainState[curr][
                                                          "variantObj"
                                                        ][innerCur.label] ===
                                                          undefined &&
                                                        mainState[curr][
                                                          "variantObj"
                                                        ][innerCur.label][
                                                          "quantity"
                                                        ] === undefined) ||
                                                      mainState[curr][
                                                        "variantObj"
                                                      ][innerCur.label][
                                                        "quantity"
                                                      ] === "-1" ||
                                                      mainState[curr][
                                                        "variantObj"
                                                      ][innerCur.label][
                                                        "quantity"
                                                      ] === -1
                                                        ? 0
                                                        : mainState[curr][
                                                            "variantObj"
                                                          ][innerCur.label][
                                                            "quantity"
                                                          ]
                                                    }
                                                  />
                                                </td>
                                                <td className="text-center py-3 ">
                                                  <input
                                                    // name="in_total"
                                                    value={
                                                      (mainState ===
                                                        undefined &&
                                                        mainState[curr] ===
                                                          undefined) ||
                                                      isNaN(
                                                        mainState[curr][
                                                          "variantObj"
                                                        ][innerCur.label][
                                                          "total"
                                                        ]
                                                      )
                                                        ? 0
                                                        : mainState[curr][
                                                            "variantObj"
                                                          ][innerCur.label][
                                                            "total"
                                                          ]
                                                    }
                                                    className="invoiceCreateSmallInputs"
                                                    placeholder="00.00"
                                                    type="text"
                                                  />
                                                </td>{" "}
                                              </tr>
                                            </tbody>
                                          </>
                                        );
                                        // return <h2>{innerCurr.label}</h2>;
                                      }
                                    )}
                                </tbody>

                                {/* <VariantTable /> */}
                              </table>
                            </>
                          ) : (
                            <div>No variant</div>
                          )}
                        </>
                      );
                    })}
                  </tbody>
                </table>

                <div className="d-flex flex-column flex-md-row mt-4 justify-content-between mx-4">
                  <div>
                    <h6>Total Item : {Object?.keys(mainState)?.length}</h6>
                  </div>
                  {/* sub_total, delivery_charge, discount, total, paid_amount, Due_amount */}
                  <div>
                    <div
                      className="d-flex justify-content-between "
                      style={{
                        color: "#212121",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      <p>Sub Total :</p>
                      <p className="ms-3 ">
                        <input
                          className="ms-3 invoiceInpCss"
                          type="text"
                          value={isNaN(getSubTotal()) ? 0 : getSubTotal()}
                        />
                      </p>
                    </div>

                    <div className="d-flex justify-content-between cl">
                      <p>Delivery Charge : </p>
                      <p className="ms-3 ">
                        <input
                          className="ms-3 invoiceInpCss"
                          type="number"
                          onChange={(e) =>
                            setCustomCharge(Number(e.target.value))
                          }
                          // value={invoice_payment_type === 0 || invoice_payment_type === "0" ? delivery_charge[invoice_delivery_charge] : 0}
                          value={getDeliveryCharge()}
                          style={{ border: "1px solid gray" }}
                        />
                      </p>
                    </div>
                    <div className="d-flex justify-content-between pl pt-2">
                      <p>
                        Discount{" "}
                        {invoice_discount_type === "0" ||
                        invoice_discount_type === 0
                          ? ""
                          : "%"}{" "}
                        :
                      </p>
                      <p className="ms-3 ">
                        <input
                          className="ms-3 invoiceInpCss paid_input_css"
                          name="invoice_paid"
                          type="text"
                          value={Discount}
                          onChange={(e) => setDiscount(e.target.value)}
                        />
                      </p>
                    </div>
                    <div
                      className="d-flex justify-content-between"
                      style={{
                        color: "#212121",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      <p>Total amount :</p>
                      <p className="ms-3 ">
                        <input
                          className="ms-3 invoiceInpCss"
                          type="text"
                          value={isNaN(getGrandTotal()) ? 0 : getGrandTotal()}
                        />
                      </p>
                    </div>

                    <div className="d-flex justify-content-between pl pt-2">
                      <p>Paid amount :</p>
                      <p className="ms-3 ">
                        <input
                          className="ms-3 invoiceInpCss paid_input_css"
                          name="invoice_paid"
                          type="text"
                          value={paid}
                          onChange={(e) => setpaid(e.target.value)}
                        />
                      </p>
                    </div>

                    <div className="d-flex justify-content-between cl">
                      <p>Due amount :</p>
                      <p className="ms-3 ">
                        <input
                          className="ms-3 invoiceInpCss"
                          type="text"
                          name="invoice_due"
                          value={isNaN(getDueAmount()) ? 0 : getDueAmount()}
                        />
                      </p>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white cat-child ">
          <div
            className="d-flex align-items-center"
            style={{ padding: "20px 24px ", border: "0.5px solid #E0E0E0" }}
          >
            <h3
              style={{ fontSize: "23px", marginTop: "6px", marginLeft: "12px" }}
            >
              Invoice Details
            </h3>
          </div>
          {/* -----------product form---------- */}
          <div className="product-main createInvoiceInputContainer">
            <div className="row">
              <div className="col-12 col-md-6">
                {/* <RequiredLabel text="Invoice Number" /> */}
                <p>Invoice Number</p>

                <InputGroup className="mb-3">
                  <Form.Control
                    disabled
                    aria-label="Username"
                    placeholder="This will be generated automatically."
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                <p>Barcode</p>
                <InputGroup className="mb-3">
                  <Form.Control
                    disabled
                    placeholder="This will be generated automatically"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                  />
                </InputGroup>
              </div>

              <div className="col-12 col-md-6">
                <RequiredLabel text="Invoice Date" />
                <div className="position-relative">
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="date"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{ backgroundColor: "#FAFAFA" }}
                      placeholder="Select a date"
                      name="invoice_date"
                      value={InvoiceAllData["invoice_date"]}
                      onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                    />
                  </InputGroup>
                  {/* <div className="calenderContainer">
                    <CalendarBlank size={20} />
                  </div> */}
                </div>
              </div>
              <div className="col-12 col-md-6 ">
                <RequiredLabel text={"Delivery Type"} />
                <div className="" style={{ height: "47px" }}>
                  <Form.Select
                    size="lg"
                    placeholder="---Select---"
                    onChange={(e) => setinvoice_delivery_type(e.target.value)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  >
                    <option value={0}>Regular</option>
                    <option value={1}>Urgent</option>
                  </Form.Select>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <RequiredLabel text="From Mobile" />
                {/* <p></p> */}

                <div className="d-flex phoneContainer ">
                  <PhoneInput
                    inputClass="phoneinput"
                    disableDropdown
                    onChange={(e) => setFromCode(e)}
                    country={"bd"}
                  />
                  {/* <PhoneInput inputClass="phoneinput" disableDropdown onChange={(e) => setFromCode(e)} enableSearch={true} country={"bd"} /> */}
                  <div className="w-100">
                    <Form.Control
                      aria-label="Input number"
                      placeholder="Input number"
                      aria-describedby="basic-addon1"
                      style={{ backgroundColor: "#FAFAFA" }}
                      className="phone_insert_input"
                      name="invoice_from_mobile"
                      value={InvoiceAllData["invoice_from_mobile"]}
                      onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <RequiredLabel text="To Mobile" />

                <div className="d-flex phoneContainer ">
                  <PhoneInput
                    inputClass="phoneinput"
                    disableDropdown
                    onChange={(e) => setToCode(e)}
                    enableSearch={true}
                    country={"bd"}
                  />
                  {/* <PhoneInput inputClass="phoneinput"  onChange={(e) => setToCode(e)} enableSearch={true} country={"bd"} /> */}
                  <div className="w-100">
                    <Form.Control
                      aria-label="Input number"
                      placeholder="Input number"
                      aria-describedby="basic-addon1"
                      style={{ backgroundColor: "#FAFAFA" }}
                      className="phone_insert_input"
                      name="invoice_to_mobile"
                      value={InvoiceAllData["invoice_to_mobile"]}
                      // onKeyUp={(e) => toPhoneHandle(e)}
                      onChange={(e) => toPhoneHandle(e)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 mt-3">
                <RequiredLabel text="Bill From" />

                <InputGroup className="mb-3">
                  <Form.Control
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    name="invoice_bill_from"
                    value={InvoiceAllData["invoice_bill_from"]}
                    onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  />
                </InputGroup>
              </div>

              <div className="col-12 col-md-6 mt-3">
                <RequiredLabel text="Bill To" />

                <InputGroup className="mb-3">
                  <Form.Control
                    name="invoice_bill_to"
                    // value={
                    //   Found
                    //     ? FoundCustomer.name
                    //     : InvoiceAllData["invoice_bill_to"]
                    // }
                    value={InvoiceAllData["invoice_bill_to"]}
                    onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                  />
                </InputGroup>
              </div>

              {/* new  */}
              <div className="col-12 col-md-6">
                <RequiredLabel text={"Discount Type"} />
                <div className="mb-3" style={{ height: "47px" }}>
                  <Form.Select
                    size="lg"
                    placeholder="---Select---"
                    onChange={(e) => setinvoice_discount_type(e.target.value)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                    value={invoice_discount_type}
                  >
                    <option value={0}>Flat </option>
                    <option value={1}>Percentage</option>
                  </Form.Select>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <RequiredLabel text={"Delivery Charge"} />
                <div className="mb-3">
                  <Form.Select
                    size="lg"
                    placeholder="---Select---"
                    value={invoice_delivery_charge}
                    onChange={(e) => {
                      if (Number(e.target.value) === 0) {
                        setCustomCharge(80);
                      } else if (Number(e.target.value) === 1) {
                        setCustomCharge(150);
                      }
                      setinvoice_delivery_charge(e.target.value);
                    }}
                    disabled
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  >
                    <option value={0}>Inside Dhaka : 80/-</option>
                    <option value={1}>Outside Dhaka : 150/-</option>
                    <option value={2}>Custom</option>
                  </Form.Select>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <RequiredLabel text="From Email" />

                <InputGroup className="mb-3">
                  <Form.Control
                    aria-label="Username"
                    type="email"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    name="invoice_from_email"
                    value={InvoiceAllData["invoice_from_email"]}
                    onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  />
                </InputGroup>
              </div>

              {Found ? (
                <div className="col-12 col-md-6 ">
                  {/* <RequiredLabel text="To Email" /> */}
                  <p>To Email</p>

                  <InputGroup className="mb-3">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{ backgroundColor: "#FAFAFA" }}
                      name="invoice_to_email"
                      type="email"
                      value={FoundCustomer.email}
                      onChange={(e) =>
                        setFoundCustomer({
                          ...FoundCustomer,
                          email: e.target.value,
                        })
                      }
                    />
                  </InputGroup>
                </div>
              ) : (
                <div className="col-12 col-md-6 ">
                  {/* <RequiredLabel text="To Email" /> */}
                  <p>To Email</p>

                  <InputGroup className="mb-3">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{ backgroundColor: "#FAFAFA" }}
                      name="invoice_to_email"
                      type="email"
                      value={InvoiceAllData["invoice_to_email"]}
                      onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                    />
                  </InputGroup>
                </div>
              )}

              <div className="col-12 col-md-6">
                <RequiredLabel text="From Address" />

                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    name="invoice_from_address"
                    value={InvoiceAllData["invoice_from_address"]}
                    onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  />
                </InputGroup>
              </div>

              <div className="col-12 col-md-6"></div>
              <div className="col-12 col-md-6">
                <RequiredLabel text="To Address 1" />

                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    aria-label="Username"
                    name="invoice_to_address"
                    value={
                      Found
                        ? FoundCustomer.to_address
                        : InvoiceAllData["invoice_to_address"]
                    }
                    onChange={(e) =>
                      Found
                        ? setFoundCustomer({
                            ...FoundCustomer,
                            to_address: e.target.value,
                          })
                        : handleInputs(e, SetInvoiceAllData)
                    }
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                <p>To Address 2</p>

                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    aria-label="Username"
                    name="invoice_to_address2"
                    value={
                      Found
                        ? FoundCustomer.to_address2
                        : InvoiceAllData["invoice_to_address2"]
                    }
                    onChange={(e) =>
                      Found
                        ? setFoundCustomer({
                            ...FoundCustomer,
                            to_address: e.target.value,
                          })
                        : handleInputs(e, SetInvoiceAllData)
                    }
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                  />
                </InputGroup>
              </div>

              {/* country */}
              <div className="col-12 col-md-6 d-none">
                <RequiredLabel text="To Country" />

                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    aria-label="Username"
                    name="to_country"
                    value={
                      Found
                        ? FoundCustomer.to_country
                        : InvoiceAllData["to_country"]
                    }
                    onChange={(e) =>
                      Found
                        ? setFoundCustomer({
                            ...FoundCustomer,
                            to_country: e.target.value,
                          })
                        : handleInputs(e, SetInvoiceAllData)
                    }
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                  />
                </InputGroup>
              </div>
              {/* divi */}
              {/* new address inputs start */}
              <div className="col-12 col-md-6">
                <RequiredLabel text="Delivery Service" />
                <Select
                  onChange={(newval) => setDeliveryService(newval)}
                  options={[
                    {
                      label: "Pathao",
                      value: 0,
                    },
                    {
                      label: "Others",
                      value: 1,
                    },
                  ]}
                  value={deliveryService}
                  placeholder="Select "
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                      boxShadow: state.isFocused
                        ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                        : "none",
                      "&:hover": {
                        borderColor: "#e0e0e0",
                      },
                      maxHeight: "120px",
                      overflowY: "auto",
                    }),
                    multiValueContainer: (baseStyles) => ({
                      ...baseStyles,
                      overflowY: "auto",
                      maxHeight: "120px",
                      display: "flex",
                      flexWrap: "wrap",
                    }),
                  }}
                />
              </div>
              {deliveryService?.value === 1 ? (
                <>
                  <div className="col-12 col-md-6">
                    <RequiredLabel text="To Division" />

                    <Controller
                      name="division"
                      control={control}
                      // rules={{ required: true }}
                      render={({ field }) => (
                        <Select
                          isSearchable
                          {...field}
                          value={selectedDivision}
                          onChange={handleDivisionChange}
                          // styles={customStyles}
                          options={divisions.map(({ name, id }) => {
                            return { label: name, value: id };
                          })}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: state.isFocused
                                ? "#e0e0e0"
                                : "#e0e0e0",
                              boxShadow: state.isFocused
                                ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                                : "none",
                              "&:hover": {
                                borderColor: "#e0e0e0",
                              },
                              maxHeight: "120px",
                              overflowY: "auto",
                            }),
                            multiValueContainer: (baseStyles) => ({
                              ...baseStyles,
                              overflowY: "auto",
                              maxHeight: "120px",
                              display: "flex",
                              flexWrap: "wrap",
                            }),
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <RequiredLabel text="To District" />
                    {/* <p>*</p> */}
                    <Controller
                      name="district"
                      control={control}
                      // rules={{ required: true }}
                      render={({ field }) => (
                        <Select
                          isLoading={selectLoading}
                          isSearchable
                          {...field}
                          value={selectedDistrict}
                          onChange={handleDistrictChange}
                          // styles={customStyles}
                          // defaultValue={ label: "", value: "" }
                          options={districtList?.map(({ name, id }) => {
                            return { label: name, value: id };
                          })}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: state.isFocused
                                ? "#e0e0e0"
                                : "#e0e0e0",
                              boxShadow: state.isFocused
                                ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                                : "none",
                              "&:hover": {
                                borderColor: "#e0e0e0",
                              },
                              maxHeight: "120px",
                              overflowY: "auto",
                            }),
                            multiValueContainer: (baseStyles) => ({
                              ...baseStyles,
                              overflowY: "auto",
                              maxHeight: "120px",
                              display: "flex",
                              flexWrap: "wrap",
                            }),
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <RequiredLabel text="To City" />

                    <Controller
                      name="town"
                      control={control}
                      // rules={{ required: true }}
                      render={({ field }) => (
                        <Select
                          isSearchable
                          {...field}
                          value={selectedTown}
                          onChange={handleTownChange}
                          // styles={customStyles}
                          // defaultValue={ label: "", value: "" }
                          options={upazillaList?.map(({ name, id }) => {
                            return { label: name, value: id };
                          })}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: state.isFocused
                                ? "#e0e0e0"
                                : "#e0e0e0",
                              boxShadow: state.isFocused
                                ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                                : "none",
                              "&:hover": {
                                borderColor: "#e0e0e0",
                              },
                              maxHeight: "120px",
                              overflowY: "auto",
                            }),
                            multiValueContainer: (baseStyles) => ({
                              ...baseStyles,
                              overflowY: "auto",
                              maxHeight: "120px",
                              display: "flex",
                              flexWrap: "wrap",
                            }),
                          }}
                        />
                      )}
                    />
                  </div>
                </>
              ) : (
                <>
                  {/* parhao data */}
                  <CreateWithPathao
                    pathaoCity={pathaoCity}
                    setPathaoCity={setPathaoCity}
                    pathaoZone={pathaoZone}
                    setPathaoZone={setPathaoZone}
                    pathaoArea={pathaoArea}
                    setPathaoArea={setPathaoArea}
                    mainState={mainState}
                    setCustomCharge={setCustomCharge}
                    subTotal={parseInt(getGrandTotal()) - customCharge}
                  />
                  {/* parhao data */}
                </>
              )}

              <div className="col-12 col-md-6 mt-2">
                {/* <RequiredLabel text="To Division" /> */}
                <p>Post Code</p>

                <input
                  style={{ width: "100%" }}
                  type="text"
                  {...register("zip")}
                />
              </div>
              {/* new address input end */}
              <div className="col-12 col-md-6 mt-2">
                <RequiredLabel text={"Payment Type"} />
                <div className="mb-3">
                  <Form.Select
                    size="lg"
                    placeholder="---Select---"
                    onChange={(e) => {
                      clearPaymentALlData();
                      setinvoice_payment_type(e.target.value);
                    }}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  >
                    {paymentType.map((curr) => {
                      return <option value={curr.value}>{curr.label}</option>;
                    })}
                  </Form.Select>
                </div>
              </div>
              <div className="col-12 col-md-6">
                {/* <RequiredLabel text="To District" /> */}
                <p>Reference ID</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    aria-label="Username"
                    name="reference_id"
                    value={paymentAllData["reference_id"]}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                  />
                </InputGroup>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`invoice-b my-4 bg-white cat-child ${
            invoice_payment_type === 0 ||
            invoice_payment_type === "0" ||
            invoice_payment_type === 6 ||
            invoice_payment_type === "6"
              ? "d-none"
              : ""
          }`}
          style={{ borderTop: "0.5px solid #E0E0E0" }}
        >
          <h4 className=" my-2 mb-4 padding-main-head">Payment Details</h4>
          <div className="border-p"></div>
          {/* ==========for bKash========== */}
          {invoice_payment_type === 3 ||
            (invoice_payment_type === "3" && (
              <div className="padding-main row">
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="bKash Number" /> */}
                  <p>Bkash Number</p>

                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="bkash_number"
                      value={paymentAllData["bkash_number"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="TRX Number" /> */}
                  <p>TNX Number</p>
                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="bkash_trx_number"
                      value={paymentAllData["bkash_trx_number"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
              </div>
            ))}
          {invoice_payment_type === 5 ||
            (invoice_payment_type === "5" && (
              <div className="padding-main row">
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="bKash Number" /> */}
                  <p>Nagad Number</p>

                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="nagad_number"
                      value={paymentAllData["nagad_number"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="TRX Number" /> */}
                  <p>TNX Number</p>
                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="nagad_trx_number"
                      value={paymentAllData["nagad_trx_number"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
              </div>
            ))}
          {/* ==========for bKash========== */}
          {/* ===========For Bank Transfer */}
          {invoice_payment_type === 2 ||
            (invoice_payment_type === "2" && (
              <div className="padding-main row">
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="Bank Name" /> */}
                  <p>Bank Name</p>

                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="bank_name"
                      value={paymentAllData["bank_name"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="Branch Name" /> */}
                  {/* <RequiredLabel text="Card Holder Name" /> */}
                  <p>Branch Name</p>

                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="banK_branch_name"
                      value={paymentAllData["banK_branch_name"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="Acount Number" /> */}
                  <p>Account Number</p>

                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="banK_account_number"
                      value={paymentAllData["banK_account_number"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="Account Name" /> */}
                  <p>Account Name</p>

                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="banK_account_name"
                      value={paymentAllData["banK_account_name"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
              </div>
            ))}

          {/* ===========For Bank Transfer=============== */}
          {/* ===========For Card Payment=============== */}
          {invoice_payment_type === 1 ||
            (invoice_payment_type === "1" && (
              <div className="padding-main row">
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="Card Number" /> */}
                  <p>Card Number</p>

                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="card_number"
                      value={paymentAllData["card_number"]}
                      // placeholder="4111111111111111"
                      // placeholder="4123412341234123"
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
                <div className="col-12 col-md-6">
                  {/* <RequiredLabel text="Card Holder Name" /> */}
                  <p>Card Holder Name</p>
                  <InputGroup className="mb-3 addressInput">
                    <Form.Control
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        backgroundColor: "#FAFAFA",
                        fontSize: "16px",
                        height: "47px",
                        borderRadius: "8px",
                        color: "#828282",
                      }}
                      name="card_holder_name"
                      value={paymentAllData["card_holder_name"]}
                      onChange={(e) => handleInputs(e, setPaymentAllData)}
                    />
                  </InputGroup>
                </div>
              </div>
            ))}

          {/* ===========For Card Payment=============== */}
        </div>

        {/* ====================attribute=================== */}
        <div
          className="product-main my-4 bg-white cat-child"
          style={{ borderTop: "0.5px solid #E0E0E0" }}
        >
          <div>
            <p>Payment Status</p>
            {invoice_payment_type === 0 || invoice_payment_type === "0" ? (
              <SelectCustomType
                options={invoice_choices1}
                setSelectedOption={setinvoice_status}
                defaultValue={[invoice_choices1[0]]}
              />
            ) : (
              <SelectCustomType
                options={invoice_choices1}
                setSelectedOption={setinvoice_status}
                defaultValue={[invoice_choices1[0]]}
              />
            )}

            {/* <SelectDropDown
              options={ invoice_choices1}
              setSelectedOptionCategory={setinvoice_status}
            /> */}
            <p className="mt-4">Delivery Status</p>
            {/* <SelectDropAuto
              options={delivery_choices}
              setSelectedOptionCategory={setDelivey_status}
            /> */}

            <SelectCustomType
              options={delivery_choices}
              setSelectedOption={setDelivey_status}
              defaultValue={[delivery_choices[0]]}
            />

            {/* notes */}
            <div className="mt-3 d-flex align-content-center">
              <PencilSimple size={12} weight="light" className="mt-0 pe-1" />{" "}
              <p style={{ color: "#333333" }} className="mb-2">
                Notes
              </p>
            </div>
            <Form.Control
              as="textarea"
              placeholder=""
              className="mb-3"
              name="invoice_notes"
              value={InvoiceAllData["invoice_notes"]}
              onChange={(e) => handleInputs(e, SetInvoiceAllData)}
              style={{
                height: "100px",
                resize: "none",
                backgroundColor: "#FAFAFA",
              }}
            />
          </div>

          <div className="row d-flex justify-content-between"></div>
        </div>

        <div
          className="padding-btn-head mb-4 d-flex justify-content-end  bg-white cat-child"
          style={{ border: "0.5px solid #E0E0E0" }}
        >
          <div className="" style={{ marginLeft: "-10px" }}>
            <button
              className={`btn rounded border align-items-center me-2 mt-2 d-none }`}
              disabled={!InvoiceAllData}
              onClick={handlePrint2}
            >
              <DoIcon className="doc" /> Preview PDF
            </button>

            {/* <button onClick={postInvoiceProduct} className="btn rounded border me-2 mt-2"> */}
            {invoiceLoader === false ? (
              <button
                onClick={() => ValidateData(false)}
                // onDoubleClick={() => showToast("success", "Invoice Creating")}
                className="btn rounded border me-2 mt-2"
              >
                Save Invoice
              </button>
            ) : (
              <button disabled className="btn rounded border me-2 mt-2">
                <MoonLoader color="black" size={10} /> Creating...
              </button>
            )}

            <button
              className="btn rounded border me-2 mt-2"
              onClick={() => history.push(path.invoice_list)}
            >
              Cancel
            </button>
            {InvoiceAllData["invoice_to_email"] !== "" &&
              !Found &&
              validateEmail(InvoiceAllData["invoice_to_email"]) && (
                <button
                  onClick={SaveAndSendEmail}
                  onDoubleClick={() => showToast("success", "Invoice Creating")}
                  className="btn rounded border text-white mt-2"
                  style={{ background: "black" }}
                >
                  Save & Send PDF
                </button>
              )}

            {Found &&
              FoundCustomer?.email !== "" &&
              validateEmail(FoundCustomer?.email) && (
                <button
                  onClick={SaveAndSendEmail}
                  onDoubleClick={() => showToast("success", "Invoice Creating")}
                  className="btn rounded border text-white mt-2"
                  style={{ background: "black" }}
                >
                  Save & Send PDF
                </button>
              )}
            <div className="d-none">
              <PreviewCreate
                print={print}
                status={invoice_payment_type}
                Found={Found}
                InvoiceAllData={InvoiceAllData}
                FoundCustomer={FoundCustomer}
                mainState={mainState}
                invStatus={invoice_status}
                Jdata={Jdata}
              ></PreviewCreate>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateInvoiceWithLoading;
